import { render, staticRenderFns } from "./sleepDruation.vue?vue&type=template&id=051c6ea6&scoped=true&"
import script from "./sleepDruation.vue?vue&type=script&lang=js&"
export * from "./sleepDruation.vue?vue&type=script&lang=js&"
import style0 from "./sleepDruation.vue?vue&type=style&index=0&id=051c6ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c6ea6",
  null
  
)

export default component.exports